// Static content for Officine Galloni — editable placeholder + real contact data.

export const BUSINESS = {
  name: "Officine Galloni",
  tagline: "Fabbri-serramentisti dal 1979",
  phone: "+39 0571 608041",
  phoneHref: "tel:+390571608041",
  whatsapp: "https://wa.me/393920539546",
  email: "info@officinegalloni.it",
  address: "Via Montelupo 21, Montespertoli (FI) 50025",
  addressShort: "Montespertoli, Firenze",
  hours: "Orari ufficio: Lun-Ven 8:00-18:00",
  piva: "P.IVA 04549210484",
  maps: "https://www.google.com/maps?q=Officine+Galloni+Via+Montelupo+21+Montespertoli&z=17&output=embed",
  instagram: "https://www.instagram.com/officine_galloni_/",
  facebook: "https://www.facebook.com/officinegalloni/?locale=it_IT",
  tiktok: "https://www.tiktok.com/@officine.galloni",
};

export const STATS = [
  { value: 47, suffix: "+", label: "Anni di esperienza" },
  { value: 3600, suffix: "+", label: "Lavori completati" },
  { value: 30, suffix: " min", label: "Tempo medio d'arrivo", text: "1-2 giorni", labelOverride: "Tempo di risposta medio" },
];

export const TRUST = [
  "Preventivo scritto e chiaro",
  "Garanzia sui lavori",
  "Artigiani esperti da 3 generazioni",
  "Prezzi trasparenti",
  "Materiali certificati",
  "Riparazioni",
  "Installazione",
  "Serietà",
];

export const SERVICES = [
  { id: "porte-blindate", n: "01", title: "Serramenti", text: "Porte, finestre, alzanti scorrevoli, persiane, bilici ecc... in acciaio e in alluminio." },
  { id: "serrature", n: "02", title: "Facciate continue e lucernari", text: "Strutture certificate su misura in alluminio." },
  { id: "cancelli", n: "03", title: "Cancelli e inferriate", text: "Cancelli e inferriate in tutti tipi di acciaio, resistenti, personalizzati e duraturi." },
  { id: "ferro-battuto", n: "04", title: "Scale e ringhiere", text: "A vostra misura ed immaginazione in acciaio." },
  { id: "restauro", n: "05", title: "Riparazioni e restauri", text: "Riparazioni e restauri a serrature, serramenti, e vecchie opere metalliche." },
  { id: "pronto-intervento", n: "06", title: "Altro", text: "Dal più piccolo oggetto di design, a tutto quello che puoi pensare realizzato grazie all'esperienza e alle nostre macchine specializzate." },
];

export const PROCESS = [
  { n: "01", title: "Contatto", text: "Ci chiami o compili il modulo e rispondiamo il prima possibile." },
  { n: "02", title: "Sopralluogo & preventivo", text: "Se necessario veniamo sul posto, prendiamo le misure e ti diamo un preventivo scritto chiaro, senza sorprese." },
  { n: "03", title: "Lavorazione", text: "Realizziamo o ripariamo con materiali e cura artigiana in ogni dettaglio." },
  { n: "04", title: "Installazione e consegna", text: "Consegnamo ed installiamo il lavoro finito, con professionalità ed esperienza, infine rispondiamo alle vostre domande." },
];

export const PORTFOLIO = [
  { id: 1, cat: "Scala", title: "Scala autoportante con parapetti in vetro", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/oc7x8x01_PHOTO-2026-06-22-20-13-16.jpg" },
  { id: 2, cat: "Facciata continua", title: "Facciata continua in alluminio con struttura in acciaio e terrazza calpestabile", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/zxdtpsn8_PHOTO-2026-06-22-20-16-08.jpg" },
  { id: 3, cat: "Serramenti", title: "Serramento con centina in acciaio", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/wbb1jkeb_PHOTO-2026-07-06-19-35-08.jpg" },
  { id: 4, cat: "Cancelli", title: "Cancello pedonale e carrabile automatizzato in acciaio Corten", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/1tn2j4n3_IMG_9366%20%281%29.jpg" },
  { id: 5, cat: "Design", title: "Scaffale personalizzato in Corten", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/jdjhpihm_IMG_9368%20%281%29.jpg" },
  { id: 6, cat: "Serramenti", title: "Serramenti con centina e vetrate in alluminio a taglio termico", img: "https://customer-assets-rejwkqb3.emergentagent.net/job_fabbro-24h-premium/artifacts/v9z71wpr_IMG_9371.jpg" },
];

export const PORTFOLIO_CATS = ["Tutti", "Cancelli", "Ferro battuto", "Restauri"];

export const SERVICE_OPTIONS = [
  "Serramenti in alluminio/acciaio",
  "Carpenteria metallica (scale, cancelli e ringhiere in ferro)",
  "Zanzariere",
  "Lucernari",
  "Persiane",
  "Facciate continue",
  "Frangisole",
  "Riparazioni",
  "Altro",
];

export const BEFORE_AFTER = {
  before: "https://images.unsplash.com/photo-1528918832583-cd56bc35dbc7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&sat=-100&exp=-20",
  after: "https://images.unsplash.com/photo-1761415452023-5e74d183efaf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const REVIEWS = [
  { name: "Marco Bianchi", stars: 5, text: "Serratura bloccata alle 23:00, sono arrivati in mezz'ora e hanno risolto senza rovinare la porta. Prezzo onesto e detto prima. Consigliatissimi." },
  { name: "Giulia Ferretti", stars: 5, text: "Cancello in ferro battuto su misura per il giardino: lavoro impeccabile, rifinito a mano. Si vede la differenza dell'artigiano vero." },
  { name: "Antonio Ricci", stars: 5, text: "Ci hanno restaurato una ringhiera d'epoca che sembrava da buttare. Ora è più bella di prima. Persone serie e puntuali." },
  { name: "Sara Conti", stars: 4, text: "Cambio serratura e porta blindata dopo un tentativo di furto. Veloci, gentili e mi hanno spiegato tutto con calma." },
  { name: "Luca Martelli", stars: 5, text: "Preventivo chiaro e nessuna sorpresa in fattura. Inferriate montate a regola d'arte. Torneremo per il cancello automatico." },
];

export const FAQ = [
  { q: "Quanto costa cambiare una serratura?", a: "Dipende dal tipo di serratura e cilindro. Per una serratura standard si parte da poche decine di euro; per cilindri europei ad alta sicurezza il costo è maggiore. Ti diamo sempre un preventivo chiaro prima di iniziare." },
  { q: "Intervenite di notte e nei festivi?", a: "Sì. Il nostro pronto intervento è attivo 24 ore su 24, 7 giorni su 7, anche nei festivi. In caso di emergenza arriviamo mediamente entro 30 minuti nella zona di Montespertoli e dintorni." },
  { q: "Fate anche lavori su misura in ferro battuto?", a: "Certo. Realizziamo cancelli, ringhiere, scale, inferriate e complementi d'arredo interamente su misura, lavorati a mano nella nostra officina." },
  { q: "Rilasciate una garanzia sui lavori?", a: "Sì, ogni lavoro è coperto da garanzia scritta. Usiamo solo materiali certificati e ti spieghiamo cosa è stato fatto e come mantenerlo." },
  { q: "In quali zone intervenite?", a: "Operiamo a Montespertoli e in tutta la provincia di Firenze: Montelupo Fiorentino, Empoli, Castelfiorentino, San Casciano, Certaldo e comuni limitrofi." },
];

export const ZONES = ["Montespertoli", "Montelupo F.no", "Empoli", "Castelfiorentino", "San Casciano", "Certaldo", "Ginestra F.na", "Baccaiano"];
